export default __webpack_public_path__ + "static/media/view-herb.579dfd9b.webp";